import React from "react";
import { Heart, Coffee } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-6 mt-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
                    {/* Brand and description */}
                    <div className="text-center md:text-left">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                            Komorebi Color Play
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            Japanese-inspired color palette generator
                        </p>
                    </div>

                    {/* Creator attribution */}
                    <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                        <span>made with</span>
                        <Heart className="h-4 w-4 text-red-500 fill-current" />
                        <span>and</span>
                        <Coffee className="h-4 w-4 text-amber-600" />
                        <span>by</span>
                        <a
                            href="https://obelisk.agency"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors duration-200"
                        >
                            obelisk
                        </a>
                    </div>

                    {/* Additional links */}
                    <div className="flex items-center space-x-6 text-sm">
                        <a
                            href="https://buymeacoffee.com/vladgramadl"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
                        >
                            Buy Me a Coffee
                        </a>
                        <a
                            href="mailto:hello@obelisk.agency"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
                        >
                            Problems. Suggestions. Bugs.
                        </a>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 text-center text-xs text-gray-500 dark:text-gray-400">
                    <p>© {new Date().getFullYear()} Obelisk. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;